<section id="job-category-maint">    
    <div class="mtn-container">
        <div class="mtn-title">
            <p>{{ moduleName }}</p>
        </div>
        <!-- Container for Job Category Table using prime ng -->
        <div class = 'table-user'>
            <osp-table [tblConfig]="jobCategoryTblConfig" (onRowClick)="onRowClick($event)"></osp-table>
        </div>
        <!-- Loading Animation -->
        <div id="job-category-maintenance-loading">
            <div class="form-loader"></div>
        </div>
        <div class="form-content" *ngIf="showForm">
            <form [formGroup]="forms.jobCategoryForm" class="form">
                <div id="job-category-error-message"></div>
                <div class="form-container-grid">
                    <div class="field">
                        <label>Category Code</label>
                    </div>
                    <div class="">
                        <input formControlName="jobCategoryCdDisp" type="text" readonly>
                    </div>
                    <div class="field required">
                        <label>Active</label>
                    </div>
                    <div class="">
                        <select formControlName="activeTag">
                            <option *ngFor="let activeType of selections.activeTypes" [value]="activeType.cd">
                                {{activeType.name}}
                            </option>
                        </select>
                    </div>

                    <div class="field required">
                        <label>Job Category</label>
                    </div>
                    <div class="">
                        <input formControlName="jobCategoryDesc" type="text" maxlength="30">
                    </div>
                    <div class="field required">
                        <label>High Risk</label>
                    </div>
                    <div class="">
                        <select formControlName="highRiskTag">
                            <option *ngFor="let highRiskType of selections.highRiskTypes" [value]="highRiskType.cd">
                                {{highRiskType.name}}
                            </option>
                        </select>
                    </div>

                    <div class="field required">
                        <label>BPIMS Code</label>
                    </div>
                    <div class="">
                        <input formControlName="bmCode" type="text" maxlength="8">
                    </div>
                    <div class="field">
                        <label>BPIMS Short Description</label>
                    </div>
                    <div class="">
                        <input formControlName="bmShortDesc" type="text" maxlength="10">
                    </div>
                    
                    <div class="field">
                        <label>Remarks</label>
                    </div>
                    <div class="span">
                        <input formControlName="remarks" type="text" maxlength="4000">
                    </div>

                    <div class="field">
                        <label>Last Update User</label>
                    </div>
                    <div class="">
                        <input type="text" readonly formControlName="userID">
                    </div>
                    <div class="field">
                        <label>Last Update</label>
                    </div>
                    <div class="">
                        <input type="text" readonly formControlName="lastUserUpdate">
                    </div>
                </div>
            </form>
            <div class="btn-row">
                <button *ngIf="btns.jobCategory.updateDisabled" class="btn btn2" type="button" (click)='onAdd()'>ADD</button>
                <button *ngIf="!btns.jobCategory.updateDisabled" class="btn btn2" type="button" (click)="onUpdate()">UPDATE</button>
                <button class="btn btn2" type="button" [disabled]='btns.jobCategory.deleteDisabled' (click)="onDelete()"> DELETE</button>
            </div>
            <div class="mtn-title"></div>
            <div class="btn-row">
                <button class="btn btn2" type="button" [disabled]='btns.jobCategory.saveDisabled' (click)="onSave()">SAVE</button>
            </div>
        </div>
    </div>
</section>